export default __webpack_public_path__ + "static/media/3a96bc92e1fa5803.139c31d6dd9b1be5fe7d2b15165b351d.svg";